import { render, staticRenderFns } from "./ProfesorInicio.vue?vue&type=template&id=59741bba"
import script from "./ProfesorInicio.vue?vue&type=script&lang=js"
export * from "./ProfesorInicio.vue?vue&type=script&lang=js"
import style0 from "./ProfesorInicio.vue?vue&type=style&index=0&id=59741bba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports